import { render } from "./PostalCodeGuide.vue?vue&type=template&id=3f08d3e8"
import script from "./PostalCodeGuide.vue?vue&type=script&lang=js"
export * from "./PostalCodeGuide.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__